import type { ConfigType } from '@plone/registry';

import { AiEditorRegistry } from './AiEditorRegistry';

export interface AiEditorSettings {
  /**
   * Which assistant client the UI talks to: the real agent through the
   * express proxy ('agent', default), or the offline in-browser mock
   * ('mock'). RAZZLE_ vars reach both bundles.
   */
  client: string;
  registry: AiEditorRegistry;
}

export default function install(config: ConfigType) {
  const settings = config.settings as Record<string, any>;
  settings.aiEditor = {
    client: process.env.RAZZLE_AI_EDITOR_CLIENT || 'agent',
    ...(settings.aiEditor || {}),
  } as AiEditorSettings;
  if (!settings.aiEditor.registry) {
    settings.aiEditor.registry = new AiEditorRegistry();
  }

  return config;
}
